import React from 'react'
import { Spin, Button, Icon, Progress } from 'antd'
import './StatusView.scss'

/**
 * A reusable view for showing status (loading, error)
 * with a consistent, premium UI/UX.
 */
const StatusView = ({
  status = 'loading', // 'loading' | 'error'
  title,
  subTitle,
  error,
  progress,
  onRetry,
  onClose,
  inline = false,
  small = false
}) => {
  const isError = status === 'error'

  return (
    <div
      className={`status-container ${small ? 'small' : ''} ${
        inline ? 'is-inline' : ''
      }`}
    >
      {status === 'loading' ? (
        <div className="status-view loading-view">
          <div className="ai-scanner-container">
            <div className="scanner-frame">
              <div className="scanner-line" />
              <div className="particle-cloud">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className={`particle p${i + 1}`} />
                ))}
              </div>
            </div>
          </div>
          <div className="text-content">
            <h3 className="status-title">{title || 'Processing...'}</h3>
            {subTitle && <p className="status-subtitle">{subTitle}</p>}
          </div>
          {progress != undefined && (
            <div className="progress-wrapper">
              <div className="progress-header">
                <span className="progress-label">Completion Status</span>
                <span className="progress-value">
                  {Math.round(Number(progress) || 0)}%
                </span>
              </div>
              <Progress
                percent={Math.round(Number(progress) || 0)}
                status="active"
                showInfo={false}
                strokeWidth={6}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="status-view error-view">
          <div className="illustration-wrapper error">
            <div className="error-icon-bg">
              <Icon type="close-circle" theme="filled" />
            </div>
          </div>
          <div className="text-content">
            <h3 className="status-title">{title || 'Something went wrong'}</h3>
            <p className="status-subtitle">
              {subTitle ||
                'We encountered an error while processing your request.'}
            </p>
          </div>

          {error && (
            <div className="error-details">
              <div className="error-scroll-area">
                <span className="error-label">Error Details</span>
                <p className="error-text">{error}</p>
              </div>
            </div>
          )}

          <div className="action-footer">
            {onClose && (
              <Button onClick={onClose} className="btn-secondary">
                Cancel
              </Button>
            )}
            {onRetry && (
              <Button type="primary" onClick={onRetry} className="btn-primary">
                Retry Now
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default StatusView
